import { useRef } from 'react';
export var useAnimatedValue = width => {
  var widthAnimated = useRef(-width).current;
  return widthAnimated;
};
//# sourceMappingURL=useAnimatedValue.js.map